var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsOptional } from 'class-validator';
import { IsWithinCalendarHorizon } from '../validators/calendar-horizon.js';
export class UpdateExerciseProgramFrequencyDto {
    trainingIsOnMonday;
    trainingIsOnTuesday;
    trainingIsOnWednesday;
    trainingIsOnThursday;
    trainingIsOnFriday;
    trainingIsOnSaturday;
    trainingIsOnSunday;
    startDate = new Date();
    endDate;
}
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramFrequencyDto.prototype, "trainingIsOnMonday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramFrequencyDto.prototype, "trainingIsOnTuesday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramFrequencyDto.prototype, "trainingIsOnWednesday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramFrequencyDto.prototype, "trainingIsOnThursday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramFrequencyDto.prototype, "trainingIsOnFriday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramFrequencyDto.prototype, "trainingIsOnSaturday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramFrequencyDto.prototype, "trainingIsOnSunday", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Date)
], UpdateExerciseProgramFrequencyDto.prototype, "startDate", void 0);
__decorate([
    IsDateString(),
    IsWithinCalendarHorizon(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UpdateExerciseProgramFrequencyDto.prototype, "endDate", void 0);
//# sourceMappingURL=update-exercise-program-frequency.dto.js.map